<template>
  <div>
    <el-container class="container">
      <NavBar :menuShow="menu_show"></NavBar>
      <el-container class="elContainerBox" >
        <div class="el-Header" :style="{'background-color': theme}">
          <div class="titleBox">
            <div class="title">
              <Breadcrumb></Breadcrumb>
            </div>
          </div>
          
          <div class="head-operate flex justify-between items-center">
            <theme-select class="switch-color"></theme-select>
            <div class="operateItem" @click="isShowXx = true">
              <div>
<!--                <img style="color: white" src="@/assets/images/gzq/notice.png" alt="">-->
                <i style="color: white;font-size: 20px" class="el-icon-bell"></i>
                <div v-if="getMessageCount != 0">{{ getMessageCount }}</div>
              </div>
              <span style="color: white">消息</span>
            </div>
            <user-opt></user-opt>
          </div>
        </div>
        <el-main style="background-color: #fff;padding:16px">
          <keep-alive :include="visitedViewList">
            <router-view :key="key"/>
          </keep-alive>
        </el-main>
      </el-container>
      <xxDialog v-if="isShowXx" :isShowXx="isShowXx" :rowData="resData" @drawerClose="drawerClose"  @changeReadXx="changeReadXx"></xxDialog>
    </el-container>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import NavBar from "@/layout/components/NavBar";
import ThemeSelect from "@/layout/components/ThemeSelect";
import UserOpt from "@/layout/components/UserOpt";
import Breadcrumb from '@/components/Breadcrumb';
// import TabView from '@/components/TabView';
import xxDialog from '@/layout/xxDialog.vue';
import {noReadCountMy} from "@/api/home/index";
export default {
  name: "layout",
  components: {
    NavBar,
    ThemeSelect,
    UserOpt,
    Breadcrumb,
    xxDialog
    // TabView
  },
  data() {
    return {
      menu_show: true,
      isShowXx:false,
      resData:{},
      count:0,
      time:null
    }
  },
  mounted() {
    // this.getNum();
    // this.time=setInterval(()=>{
    //   this.getNum();
    // },60000)
  },
  methods: {
    showMenu() {
      this.menu_show = !this.menu_show;
    },
    changeReadXx(){
      // this.getNum();
    },
    drawerClose() {
      this.isShowXx = false;
    },
    // 获取未读消息数量
    getNum(){
      noReadCountMy({}).then(res=>{
        if(res && res.code == 200){
          // if((Number(this.count)<Number(res.data.count))&&this.count!==0){
          //   this.$notify({
          //     title: '提示',
          //     message: '有新审批需要处理',
          //     type: 'success',
          //     duration: 0
          //   });
          // }
          if(res.data.count!=0){
            this.$notify({
              title: '提示',
              message: '您有新消息未读，请及时处理！',
              type: 'success',
              duration: 60000
            });
          }
          this.count = res.data.count;
        }
      })
    },
  },
  computed: {
    ...mapGetters([
      'theme',
      'headerTheme',
      'getMessageCount'
    ]),
    noCachedViewList() {
      return this.$store.state.tagsView.noCachedViewList
    },
    visitedViewList() {
      return this.$store.state.tagsView.visitedViewList
    },
    key() {
      return this.$route.fullPath
    }
  }
};
</script>

<style scoped lang='scss'>
.container {
  height: 100%;
  overflow: hidden;
}

.el-Header {
  padding: 0 30px;
  background-color: #ffffff;
  // background-image: url("~@/assets/images/sys/headerBj.png");
  // background-repeat: no-repeat;
  // background-position: center;
  // background-size: 100% 100%;
  min-height: 74px;
  color: #464D5A;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #EDF0F2;
  .titleBox {
    display: flex;
    align-items: center;

    > img {
      cursor: pointer;
    }
  }
  .head-operate{
    width: 300px;
    height: 100%;
    .switch-color{
      padding-top: 3.5px;
      box-sizing: border-box;
    }
    // background: red;
  }
}

.title {
  display: flex;
  flex-flow: column;
  width: fit-content;
  // margin-left: 18px;

  p:nth-child(1) {
    font-weight: 600;
    font-size: 18px;
    line-height: 160%;
    /* identical to box height, or 29px */
    letter-spacing: 0.735em;
    color: $mainColor;
  }

  p:nth-child(2) {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    letter-spacing: 0.01em;
    color: #3569A9;
  }
}

/deep/ .el-main {
  padding: 0px;
  overflow-y: scroll;
}

.el-main::-webkit-scrollbar {
  display: none;
}

.elContainerBox {
  // padding: 0px 10px 15px;
  display: flex;
  flex-flow: column;
}

.turnMenu {
  transform: rotate(180deg);
}
.operateItem{
  display: flex;
  align-items: center;
  // min-width: 120px;
  height: 36px;
  display: flex;
  place-content: center;
  place-items: center;
  cursor: pointer;
  margin-right: 24px;
  >div{
    position: relative;
    >img{
      width: 24px;
      height: 24px;
    }
    >div{
      position: absolute;
      top:-7px;
      right: -7px;
      width: 13px;
      height: 11px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: #ff4958;
      color: #ffffff;
      font-family: "Alibaba PuHuiTi 3.0";
      font-weight: 700;
      font-size: 7px;
    }
  }
  >img{
    width: 24px;
    height: 24px;
  }
  >span{
    color: #464D5A;
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: 400;
    font-size: 14px;
    padding-left: 6px;
  }
}

</style>
